import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { Button } from '../ui/Button';
const RESOURCES = [{
  title: 'Property disclosure guide',
  desc: 'What buyers should look for before signing.',
  href: '/resources'
}, {
  title: 'Buying at auction checklist',
  desc: 'What to organise before auction day.',
  href: '/resources'
}, {
  title: 'SMSF property purchase guide',
  desc: 'Questions to resolve with your legal and financial advisers.',
  href: '/resources'
}];
export function Resources() {
  return <section className="bg-background px-5 py-10 md:px-6 md:py-14" data-id="element-334" data-mp="3860t374cfojg">
      <div className="mx-auto max-w-7xl" data-id="element-335" data-mp="3d5wzfd0ijs26">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-336" data-mp="3d6y9pf9pgaiu">
          <div data-id="element-337" data-mp="nhmj6x8tngjg">
            <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-338" data-mp="nftehnhrr6e3">
              <div className="max-w-md" data-id="element-339" data-mp="semq1adhwnbm">
                <p className="eyebrow text-brand-blue" data-id="element-340" data-mp="shr1mstailcb">do your homework</p>
                <h2 className="mt-2 text-3xl leading-tight text-ink md:text-[2.6rem]" data-id="element-341" data-mp="7ekhs4hjy1k8">
                  Understand the transaction before you decide.
                </h2>
              </div>
              <Link to="/resources" className="inline-flex shrink-0 items-center gap-1.5 font-semibold text-brand-blue transition-colors hover:text-brand-blue-dark" data-id="element-342" data-mp="3tkpp8ewqf5qu">
                View all guides
                <ArrowRightIcon className="h-4 w-4" data-id="element-343" data-mp="3fuvy1pxr89dy" />
              </Link>
            </div>

            <div className="border-t border-border" data-id="element-344" data-mp="3avsu68tig97k">
              {RESOURCES.map((resource, index) => <Link key={resource.title} to={resource.href} className="group grid grid-cols-[2.5rem_1fr_auto] items-center gap-4 border-b border-border py-6" data-id="element-345" data-mp="35wye3emxgyr5" data-mpi={index}>
                  <span className="text-sm font-semibold text-peach-dark" data-id="element-346" data-mp="2wx2z0yq94jlu">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span data-id="element-347" data-mp="2r9zo7o3pycej">
                    <span className="block font-serif text-xl text-ink transition-colors group-hover:text-brand-blue" data-id="element-348" data-mp="2raiycin4nwi0">
                      {resource.title}
                    </span>
                    <span className="mt-1 block text-sm text-muted-ink" data-id="element-349" data-mp="2i91hgy1wbqs9">
                      {resource.desc}
                    </span>
                  </span>
                  <ArrowUpRightIcon className="h-5 w-5 text-muted-ink transition-colors group-hover:text-brand-blue" data-id="element-350" data-mp="35zp1uit008vp" />
                </Link>)}
            </div>
          </div>

          <div data-id="element-351" data-mp="2w8knnlb5cs1x">
            <div className="border-t-4 border-peach bg-accent-soft p-7 md:p-9 lg:sticky lg:top-28" data-id="element-352" data-mp="2w6zv218e7j6p">
              <h3 className="font-serif text-2xl leading-snug text-ink md:text-[1.7rem]" data-id="element-353" data-mp="3162sazi4sl44">
                Get the Australian buyer contract checklist.
              </h3>
              <p className="mt-3 text-muted-ink" data-id="element-354" data-mp="3tq19dskc03lr">
                The exact documents and conditions worth checking before you
                sign, in one practical PDF.
              </p>

              <form className="mt-7 space-y-4" onSubmit={event => event.preventDefault()} data-id="element-355" data-mp="2vixmcsezc7y">
                <div data-id="element-356" data-mp="gmnqmw1a169b">
                  <label htmlFor="lc-firstname" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-357" data-mp="gmxhelu5bhg2">
                    First name
                  </label>
                  <input id="lc-firstname" type="text" autoComplete="given-name" className="h-12 w-full rounded-xl border border-border bg-surface px-4 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/25" data-id="element-358" data-mp="3k3ns3e0oaio3" />
                </div>
                <div data-id="element-359" data-mp="3p27hxpie0elq">
                  <label htmlFor="lc-email" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-360" data-mp="19ce6pamgyi82">
                    Email
                  </label>
                  <input id="lc-email" type="email" autoComplete="email" className="h-12 w-full rounded-xl border border-border bg-surface px-4 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/25" data-id="element-361" data-mp="14ci2pbdruqsi" />
                </div>
                <div data-id="element-362" data-mp="3k246a3eq3h0o">
                  <label htmlFor="lc-stage" className="mb-1.5 block text-sm font-medium text-ink" data-id="element-363" data-mp="3o136xbtf8rmb">
                    Buyer type or stage
                  </label>
                  <select id="lc-stage" className="h-12 w-full appearance-none rounded-xl border border-border bg-surface px-4 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/25" data-id="element-364" data-mp="3sybslmds3dsb">
                    <option value="" data-id="element-365" data-mp="biwqwqaxsegx">Select an option</option>
                    <option data-id="element-366" data-mp="fltbgmk1ekni">First home buyer</option>
                    <option data-id="element-367" data-mp="fn4h6rx1m2h9">Investor</option>
                    <option data-id="element-368" data-mp="kkczqtm3s8j1">Upsizing or downsizing</option>
                    <option data-id="element-369" data-mp="kkw6de6azahr">SMSF or trust buyer</option>
                    <option data-id="element-370" data-mp="2536rhcbczam3">Just researching</option>
                  </select>
                </div>

                <label className="flex cursor-pointer items-start gap-3 pt-1" data-id="element-371" data-mp="203aw21gq8ri5">
                  <input type="checkbox" className="mt-1 h-4 w-4 rounded border-border text-accent focus:ring-accent/30" data-id="element-372" data-mp="1w1pbrv1v5axx" />
                  <span className="text-xs leading-relaxed text-muted-ink" data-id="element-373" data-mp="1r58muymuasjs">
                    Yes, send me the checklist and the occasional Australian
                    property update. I can unsubscribe at any time.
                  </span>
                </label>

                <Button type="submit" variant="accent" fullWidth size="lg" data-id="element-374" data-mp="2eza2z8s3ollp">
                  Send me the checklist
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}